import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { hasYesOrNo } from 'models/validate';
import { FinancialCivilJudgementItemModel } from '../types';
import { pvqCivilJudgmentLocationValidator } from './pvqCivilJudgmentLocationValidator';

export const pvqFinancialCivilJudgementItemValidator: ValidateJSModel<FinancialCivilJudgementItemModel> = {
  ActionsTaken: (value, attributes) => {
    if (attributes?.HasBeenPaid?.value === 'No' && attributes?.ActionsTakenNone?.applicable !== false) {
      return { hasValue: true };
    }
    return {};
  },

  ActionsTakenNone: {},

  ActionsTakenReason: (value, attributes) => {
    if (attributes?.ActionsTakenNone?.applicable === false && attributes?.HasBeenPaid?.value === 'No') {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },

  AmountOfJudgement: {
    presence: true,
    model: { validator: currencyModelValidator },
  },

  AmountOfJudgementEstimated: {},

  CourtLocation: {
    presence: true,
    location: {
      validator: pvqCivilJudgmentLocationValidator,
      requireCounty: false,
    }
  },

  CourtName: {
    presence: true,
    hasValue: true,
  },

  HasBeenPaid: { hasValue: { validator: hasYesOrNo } },

  OrderNum: (value, attributes, attributeName, options) => {
    if (attributes?.OrderNumIdk?.applicable !== false) {
      return {
        presence: true,
        hasValue: true
      };
    }

    return {};
  },

  OrderNumIdk: {},

  OtherParties: { hasValue: true },

  When: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { earliest: options?.applicantBirthdate, latest: DEFAULT_LATEST },
  }),

  WhenEstimated: {},

  WhenPaid: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;
    return attributes.HasBeenPaid?.value === 'Yes' ? {
      presence: true,
      date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
    } : {};
  },

  WhenPaidEstimated: {},

  Why: { hasValue: true },
};
